import React, { useEffect, useState } from "react";
import "./search.page.scss";
import { IonPage } from "@ionic/react";
import TabHeader from "../../../web/components/tabs/TabHeader";
import { SectionContainer } from "../../containers/SearchContainer/sectionContainer";
import TopRecommendations from "./TopRecommendations/TopRecommendations";
import { createStructuredSelector } from "reselect";
import {
  getTopRecommended,
  makeSelectRecommended,
  makeSelectWatched
} from "../../../selectors/Home/selector";
import { RecommendedModel } from "../../../models/home/Loads.model";
import { getUserMasterData } from "../../../selectors/selector";
import { compose } from "redux";
import { Isearch } from "../../../schemas/Search/Search.schema";
import {
  PAGE_TITLES,
  SORTING_ORDER_ASC,
  TOP_RECOMMENDED_LOAD_COUNT,
  SEARCH_TITLE,
  RECOMMENDATION_COUNT,
  RECOMMENDED_TAB,
  WATCHED_TAB,
  WATCHED_TAB_HEADING,
  RECOMMENDED_TAB_HEADING
} from "../../../utils/constants";
import { connect } from "react-redux";
import { recommendedLoadsRequest } from "../../../actions/Home/action";
import { LPEFeedBackLogEvent } from "./TopRecommendations/utils";
import { EVENT, SCREEN } from "../../../utils/constants.analytics";
import { IUserDetails } from "../../../schemas/user";

interface SearchProps {
  userDetails: IUserDetails;
  segmenName: string;
  doScroll: any;
  recommendedData?: any;
  getTopRecommData: any;
  getRecommendedLoadsData?: any;
  getWatchedLoadsData?: any;
}
const Search = (props: SearchProps) => {
  const { segmenName, doScroll } = props;
  const module = SEARCH_TITLE;
  const [segment, setSegment] = useState<any>({ name: segmenName, data: {} });
  const [isRecentSearch, setRecentSearch] = useState<boolean>(false);
  const [searchParams, setSearchParms] = useState({});
  const [loadIdClicked, setloadIdClicked] = useState<any>(undefined);
  const [navigateTo, setnavigateTo] = useState<any>("");
  const onChangeSegment = (segmentName: string, searchParams: Isearch) => {
    setSegment({ name: segmentName, data: {} });
  };
  const getTopRecommendedLoads = (
    refreshStatus = false,
    callback = false,
    sorRefresh = false
  ) => {
    const _RecommendedModel: RecommendedModel = new RecommendedModel();
    props.recommendedData({
      query: _RecommendedModel.getRequestPayload(),
      refreshStatus,
      sorRefresh,
      callback,
      isTopRecomm: true
    });
  };
  useEffect(() => {
    /**
     * Top Recommended API should be called everytime when
     * User navigates to Search Screen
     */
    getTopRecommendedLoads();
  }, []);
  useEffect(() => {
    if(segment.name === WATCHED_TAB_HEADING)
    {
      setnavigateTo(WATCHED_TAB)
    }
    else if(segment.name === RECOMMENDED_TAB_HEADING)
    {
      setnavigateTo(RECOMMENDED_TAB)
    }
  }, [segment]);
  const onCardClickEvent = (loadId: string) => {
    let isWatchedLoadExists = false
    const { topRecommData } = props.getTopRecommData;
    const { getWatchedLoadsData } = props;
    getWatchedLoadsData && getWatchedLoadsData.forEach((watchedLoad:any) => { if(watchedLoad.loadId == loadId)isWatchedLoadExists = true});
    if(isWatchedLoadExists){
      setnavigateTo(WATCHED_TAB)
    }
    else{
      setnavigateTo(RECOMMENDED_TAB)
    }
    topRecommData.forEach((loadData: any) => {
      if (loadId == loadData.loadId) {
        setSegment({ name: "Matched Loads", data: {} });
        setloadIdClicked(loadData.loadId);
        LPEFeedBackLogEvent(
          EVENT.UE_SEARCH_HEADER_RECOMMENDED_LOAD_DETAILS,
          SCREEN.SEARCH,
          loadData.loadId,
          module,
          loadData.rank,
          loadData.resultId
        );
        let loadTileDOM = document.getElementById(`top_recomm_load_clicked`);
        if (loadTileDOM) {
          loadTileDOM && loadTileDOM.focus();
          loadTileDOM.style.outline = "none";
        }
      }
    });
  };
  const check = (e:any) => {
    if(loadIdClicked) setloadIdClicked(undefined)
  }
  const isTopRecommendationsVisible = (props:any) =>{
    return props.userDetails && props.userDetails.memberDetailsResponse && 
    props.userDetails.memberDetailsResponse.member && 
    props.userDetails.memberDetailsResponse.member.upn &&
    props.getTopRecommData &&
    props.getTopRecommData.topRecommData &&
    props.getTopRecommData.topRecommData.length > 0 &&
    props.userDetails.memberDetailsResponse.carrierInfo.source !== "ASL"
    

  }
  return (
    <>
      <IonPage className="desktop-page search-page">
        <h1 className="heading-search">{PAGE_TITLES.SEARCH}</h1>
        <TopRecommendations
            isTopRecomm={isTopRecommendationsVisible(props)}
            loadsToShow={TOP_RECOMMENDED_LOAD_COUNT}
            onCardClick={(loadId: string) => onCardClickEvent(loadId)}
            loadDetails={
              props.getTopRecommData && props.getTopRecommData.topRecommData
            }
            userDetails={props.userDetails}
            refreshTopRecommend={() => { setTimeout(() => {getTopRecommendedLoads()}, 3000)}} // refresh Top Recommedation result after 1 Second
            module={RECOMMENDATION_COUNT}
          />
        <TabHeader
          setSegment={setSegment}
          segments={[
            "New Search",
            "Recent Search",
            "Favorite Search",
            "Watched Loads",
            "Recommended Loads"
          ]}
          activeSegment={segment.name}
        />
        <div
          id="top_recomm_load_clicked"
          tabIndex={1}
          className="load-page-content search-page-content"
        >
          <SectionContainer
            topRecommNavigate={navigateTo}
            topRecommLoadClick={loadIdClicked}
            onRedirectToTab={onChangeSegment}
            section={segment.name}
            isRecentSearch={isRecentSearch}
            userDetails={props.userDetails}
            searchParams={searchParams}
            doScroll={doScroll}
            tabCallbackSegmentChange={(segment:any)=> setnavigateTo(segment.name)}
            clearTopRecommedLoadDetails={(e:any)=>{check(e) } }
          />
        </div>
      </IonPage>
    </>
  );
};
const mapStateToProps = createStructuredSelector({
  userDetails: getUserMasterData(),
  getTopRecommData: getTopRecommended(),
  getRecommendedLoadsData: makeSelectRecommended(),
  getWatchedLoadsData: makeSelectWatched()
});
export const mapDispatchToProps = (dispatch: Function) => ({
  recommendedData: (payload: any) => dispatch(recommendedLoadsRequest(payload)),
});
const key = "myload";
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose<any>(withConnect)(Search);